
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCreateTaskChangeRequestDto } from '../models/work-create-task-change-request-dto';

export function getCreateTaskChangeRequestsBulkDtoFormGroup() {
return new FormGroup({
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    entries: new FormControl<WorkCreateTaskChangeRequestDto[]>([]),
    notes: new FormControl<string | undefined>('', [Validators.maxLength(1000)]),
})
;
}
      